// extracted by mini-css-extract-plugin
export default {"stats":"stats_stats__oQQIQ","stat":"stats_stat__OeNR2","row":"stats_row__1r6nS"};